import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
  insuranceProviderAction,
  relationAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import DatePicker from "react-datepicker";
import ItemsInputField from "../forms/items-input-field";
import TickIcon from "../../assets/icons/tick-icon";
import SelectField from "../forms/select-field";
import InfoIcon from "../../assets/icons/admin-customer-icons/info-icon";
import BusinessIcon from "../../assets/icons/admin-customer-icons/business-icon";
import ConsolidationIcon from "../../assets/icons/admin-customer-icons/consolidation";
import Accounting2Icon from "../../assets/icons/admin-customer-icons/accounting2-icon";

function Accounting({
  customerId,
  banking,
  page,
  disabled,
  // loading,
  // setLoading,
}) {
  const [defaultPay, setDefaultPay] = useState("");
  const [defaultShipping, setDefaultShipping] = useState("");
  const [insuranceProvider, setInsuranceProvider] = useState(null);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  // console.log(localStorageData, "aaa");
  const dispatch = useDispatch();

  const initialValues = {
    insurance: localStorageData?.banking ?? banking,
  };

  const addInsurance = {
    cmr_id: customerId,
    cmr_bank_id: "01K1FG6PQVR8TENM63YBXC77KR",
    cmr_bank_name: "",
    cmr_account_no: "",
    cmr_ifsc_code: "",
    cmr_bank_branch: "",
    cmr_default_bank_details: false,
  };

  // const UpdateLocalStorage = ({ values }) => {
  //   useEffect(() => {
  //     console.log("initialValues", initialValues);
  //     localStorage.setItem("customerAdmin", JSON.stringify(values));
  //   }, [values]);
  //   return null;
  // };
  //   useEffect(() => {}, []);
  function convertArray(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
    }));
  }
  const onSuccess = (data) => {
    // setLoading(false);
    successToast(data.message);
  };
  const onInsuranceSuccess = (data) => {
    console.log("dataa", data);
    const res = convertArray(data.data);
    setInsuranceProvider(res);
    // setLoading(false);
  };
  const onError = (data) => {
    // setLoading(false);
    errorToast(data.message);
  };

  useEffect(() => {
    // if (!loading) {
    // setLoading(true);
    dispatch(insuranceProviderAction(onInsuranceSuccess, onError));
    // }
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          insurance: values.insurance,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
    }, [values, isInitialRender]);

    return null;
  };
  const handleDefaultBank = (values, setFieldValue, selectedIndex) => {
    const updatedBank = values.insurance.map((item, index) => ({
      ...item,
      cmr_is_default: index === selectedIndex,
    }));

    setFieldValue("insurance", updatedBank);
  };

  const handleAddInsurance = (values, setFieldValue) => {
    const updatedInsurance = [...values.insurance, { ...addInsurance }];
    setFieldValue("insurance", updatedInsurance);
  };

  const handleDeleteInsurance = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one insurance");
    else if (values.insurance[index].cmr_is_default === true) {
      return errorToast("Cannot delete the default insurance");
    } else {
      const updatedBank = values.insurance.filter((_, i) => i !== index);
      setFieldValue("insurance", updatedBank);
    }
  };

  const onSave = (values, { validateForm, errors }) => {
    // if (loading) return;
    // setLoading(true);
    dispatch(
      adminCustomerUpdateContactPersonAction(
        values.insurance,
        onSuccess,
        onError
      )
    );
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      // validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form>
          {console.log(values)}
          <UpdateLocalStorage values={values} />
          <div className="flex flex-col gap-6 my-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Accounting2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Accounting Information
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Manage financial and accounting details
                  </label>
                </div>
              </div>
              <div className="flex gap-[6px]">
                <div className="px-5 py-[5px] rounded-full bg-[var(--customer-default-bg)] flex items-center">
                  <label className="text-[var(--customer-default-fg)] font-[var(--customer-default-fw)]">
                    Active
                  </label>
                </div>
              </div>
            </div>

            <div className="flex flex-row gap-3 w-full">
              <div className="w-full flex flex-col gap-6">
                <div className="gap-4 rounded-xl px-[25px] pt-[25px] pb-[5] flex flex-col justify-between bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]">
                  <div className="flex flex-row justify-between">
                    <div className="w-full flex flex-row gap-2">
                      <div className="w-8 h-8 flex items-center justify-center bg-[var(--customer-info2-fg)] rounded-lg">
                        <BusinessIcon />
                      </div>
                      <label
                        className={`self-center items-center text-[var(--customer-sub-title-fg)] text-[length:var(--customer-sub-title-fs)] font-[var(--customer-sub-title-2-fw)] w-full`}
                      >
                        Business Partner
                      </label>
                    </div>
                    <div className="whitespace-nowrap px-5 py-[5px] rounded-full bg-[var(--customer-read-bg)] flex items-center">
                      <label className="text-[var(--customer-read-fg)] font-[var(--customer-default-fw)]">
                        Read Only
                      </label>
                    </div>
                  </div>
                  <SelectField
                    // defaultValue={terms?.find(
                    //   (option) =>
                    //     option?.label === values?.patient?.cmr_primary_doctor
                    // )}
                    label=""
                    labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                    general_color="true"
                    borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                    isContainer={true}
                    containerClass={`${
                      disabled ? "cursor-not-allowed" : ""
                    } w-full flex flex-col gap-2`}
                    parentClass={`${
                      disabled ? "cursor-not-allowed" : ""
                    } w-full flex flex-col gap-2`}
                    isDisabled={disabled}
                    // errMsgContainerClass="hidden"
                    id={`patient.cmr_primary_doctor`}
                    placeholder="Select Business Partner"
                    options={insuranceProvider}
                    name={`patient.cmr_primary_doctor`}
                    isSearchable={true}
                    isRequired={true}
                  />
                </div>
                <div className="gap-4 rounded-xl p-[25px] flex flex-col justify-between bg-gradient-to-br from-[var(--customer-consol-from-gb)] to-blue-[var(--customer-consol-to-gb)] border-[2px] border-[var(--customer-consol-border-color)]">
                  <div className="flex flex-row justify-between">
                    <div className="w-full flex flex-row gap-2">
                      <div className="w-8 h-8 flex items-center justify-center bg-[var(--customer-consol-icon-gb)] rounded-lg">
                        <ConsolidationIcon />
                      </div>
                      <label
                        className={`self-center items-center text-[var(--customer-sub-title-fg)] text-[length:var(--customer-sub-title-fs)] font-[var(--customer-sub-title-2-fw)] w-full`}
                      >
                        Consolidation Options
                      </label>
                    </div>
                    <div className="whitespace-nowrap px-5 py-[5px] rounded-full bg-[var(--customer-read-bg)] flex items-center">
                      <label className="text-[var(--customer-read-fg)] font-[var(--customer-default-fw)]">
                        Disabled
                      </label>
                    </div>
                  </div>
                  <div className="w-full rounded-lg p-[13px] border border-[var(--customer-business-border)] flex flex-row gap-3 bg-white">
                    <input
                      type="checkbox"
                      disabled={true}
                      className="w-5 h-5 self-center"
                    />
                    <div className="flex flex-col">
                      <label
                        className={`text-[var(--alert-management-label-color)] text-[length:var(--customer-info-fs)] font-[var(--customer-default-fw)] w-full`}
                      >
                        Payment Consolidation
                      </label>
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Group multiple payments together
                      </label>
                    </div>
                  </div>
                  <div className="w-full rounded-lg p-[13px] border border-[var(--customer-business-border)] flex flex-row gap-3 bg-white">
                    <input
                      type="checkbox"
                      disabled={true}
                      className="w-5 h-5 self-center"
                    />
                    <div className="flex flex-col">
                      <label
                        className={`text-[var(--alert-management-label-color)] text-[length:var(--customer-info-fs)] font-[var(--customer-default-fw)] w-full`}
                      >
                        Delivery Consolidation
                      </label>
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Combine multiple deliveries
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-col gap-6">
                <div className="gap-4 rounded-xl p-[25px] flex flex-col justify-between bg-gradient-to-br from-[var(--customer-consol-from-gb)] to-blue-[var(--customer-consol-to-gb)] border-[2px] border-[var(--customer-consol-border-color)]">
                  <div className="flex flex-row justify-between">
                    <div className="w-full flex flex-row gap-2">
                      <label
                        className={`self-center items-center text-[var(--customer-sub-title-fg)] text-[length:var(--customer-sub-title-fs)] font-[var(--customer-sub-title-2-fw)] w-full`}
                      >
                        Financial Overview
                      </label>
                    </div>
                  </div>
                  <div className="w-full rounded-lg p-[13px] border border-[var(--customer-business-border)] flex flex-row gap-3 bg-white">
                    <input
                      type="checkbox"
                      disabled={true}
                      className="w-5 h-5 self-center"
                    />
                    <div className="flex flex-col">
                      <label
                        className={`text-[var(--alert-management-label-color)] text-[length:var(--customer-info-fs)] font-[var(--customer-default-fw)] w-full`}
                      >
                        Payment Consolidation
                      </label>
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Group multiple payments together
                      </label>
                    </div>
                  </div>
                  <div className="w-full rounded-lg p-[13px] border border-[var(--customer-business-border)] flex flex-row gap-3 bg-white">
                    <input
                      type="checkbox"
                      disabled={true}
                      className="w-5 h-5 self-center"
                    />
                    <div className="flex flex-col">
                      <label
                        className={`text-[var(--alert-management-label-color)] text-[length:var(--customer-info-fs)] font-[var(--customer-default-fw)] w-full`}
                      >
                        Delivery Consolidation
                      </label>
                      <label
                        className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-label1-fs)] font-[var(--customer-nav-fw)] w-full`}
                      >
                        Combine multiple deliveries
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[var(--customer-input-section-from-bg)] rounded-lg flex flex-col gap-2 p-4">
              <div className="flex gap-2">
                <InfoIcon />
                <label
                  className={`text-[var(--customer-info2-fg)] text-[length:var(--customer-current-nav-fs)] font-[var(--customer-default-fw)] w-full`}
                >
                  Accounting Information
                </label>
              </div>

              <label
                className={`text-[var(--customer-info2-fg)] text-[length:var(--customer-info-fs)] font-[var(--customer-nav-fw)] w-full`}
              >
                Some fields in this section are read-only and will be
                automatically populated based on transaction history. The
                visibility and editability of fields depend on the Party Type
                selected in the General tab.
              </label>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Accounting;
